// @ts-nocheck
export const FETCH_DASHBOARD_EVENTS_REQUEST = "FETCH_DASHBOARD_EVENTS_REQUEST";
export const FETCH_DASHBOARD_EVENTS_SUCCESS = "FETCH_DASHBOARD_EVENTS_SUCCESS";
export const FETCH_DASHBOARD_EVENTS_FAILURE = "FETCH_DASHBOARD_EVENTS_FAILURE";